var _path, _path2, _rect, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805H5.99609C5.46566 1.99805 4.95695 2.20876 4.58188 2.58383C4.20681 2.95891 3.99609 3.46761 3.99609 3.99805V19.998C3.99609 20.5285 4.20681 21.0372 4.58188 21.4123C4.95695 21.7873 5.46566 21.998 5.99609 21.998H17.9961C18.5265 21.998 19.0352 21.7873 19.4103 21.4123C19.7854 21.0372 19.9961 20.5285 19.9961 19.998V8.99805L12.9961 1.99805Z",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805V8.99805H19.9961",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13.52,
    width: 24,
    height: 10.48,
    rx: 2,
    fill: "#7755FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2715 22V15.52H19.7035V21.032H21.1915V22H18.2715Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1348 22L12.2468 15.52H13.7828L14.4948 19.288L15.2628 15.52H16.7428L16.8548 22H15.8388L15.7188 17.688L14.9668 22H14.0628L13.2628 17.656L13.1668 22H12.1348Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73137 22V16.584H7.75537V15.52H11.1394V16.584H10.1714V22H8.73137Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80859 22V15.52H4.24059V18.144H5.24059V15.52H6.68059V22H5.24059V19.168H4.24059V22H2.80859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlIcon);
export default __webpack_public_path__ + "static/media/htmlIcon.c00e90c236b1259acbdcfb9d7213e02e.svg";
export { ForwardRef as ReactComponent };